import { routesInApi } from '../../constants/routes';
import { getProfile } from '../../services/account';
import { signInWithToken } from '../../services/auth';
import {
  getCitiesWithTheatres,
  getFilmBasic,
  getFilmWthSchedule,
  getHallStatus,
  getNotifications,
  getSessionPrices,
  getTheatre,
  getTheatresByCity,
  getCities,
  getTheatrePaymentInfo,
  getPrivacyDocuments
} from '../../services/data';
import { getUserSession, pageChangeLog } from '../../services/log';
import {
  getResultPayment,
  getProcessingResult,
  privacyPolicy,
  reserveBar,
  reserveTicket,
  submitOrder,
  useDiscountPromoCode,
} from '../../services/order';
import { setting } from '../../setting';
import { types } from '../../types';
import { bar } from './bar';
import { logs } from './logs';
import { schedule } from './schedule';
import { auth } from '@/store/actions/auth';
import axios from 'axios';
import router from '../../../src/router';
import { giftCardError } from '../../helpers/giftCards';
import urlQueryParts from '../../helpers/urlQueryParts';
import errorException from '@/helpers/errorException';

const actions = {
  ...logs,
  ...schedule,
  ...bar,
  ...auth,

  async startApp({ commit }, { cookieToken, startRouteName, currency }) {
    commit(types.SET_LOADING, { startApp: true });

    try {
      if (cookieToken) {
        const authToken = await signInWithToken({ Token: cookieToken });
        localStorage.setItem('widgetToken', authToken.AccessToken);
        commit(types.SET_AUTH_TOKEN, authToken);
        commit(types.SET_ID_TOKEN, authToken);
      }

      const userSessionGuid = await getUserSession();
      commit(types.SET_USER_SESSION_ID, userSessionGuid);

      commit(types.SET_CURRENCY, currency);

      const PageType = routesInApi.find(
        (page) => page.name === startRouteName,
      ).api;

      if (
        startRouteName !== 'BeforePage' &&
        // startRouteName !== 'generalSchedule' &&
        startRouteName !== 'filmSchedule'
      ) {
        await pageChangeLog(
          { PageType, Direction: 'Forward' },
          userSessionGuid,
        );
      }
    } catch (e) {
      errorException(e, commit, 'startApp');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { startApp: false });
    }
  },

  async loadPageAfterPayment({ state, commit }, { userSession, orderId }) {
    if (state.orderInfo) {
      return;
    }

    try {
      commit(types.SET_LOADING, { loadPageAfterPayment: true });
      commit(types.SET_USER_SESSION_ID, userSession);

      if (userSession)
        await pageChangeLog(
          { PageType: 'ToPaymentResult', Direction: 'Forward' },
          userSession,
        );
      else
        throw new Error(
          'Если вы только что оплатили заказ, то вы его можете найти на почте, данная страница более не доступна',
        );

      let timeBeforeNextRequest = 1000;

      const getResultData = async () => {
        try {
          commit(types.SET_LOADING, { getProcessingResult: true });
          const resultData = await getProcessingResult(
            { status: 'Paid', paymentId: orderId },
            userSession,
          );
          commit(types.SET_ORDER_INFO_AFTER_PAYMENT, resultData);
          commit(types.SET_LOADING, { getProcessingResult: false });
        } catch (e) {
          if (timeBeforeNextRequest > 6000) {
            commit(
              types.ADD_ERROR,
              'Произошла ошибка. Попробуйте повторить попытку позже.',
            );
            commit(types.SET_LOADING, { getProcessingResult: false });
            return { success: false, error: e.message };
          }

          setTimeout(async () => await getResultData(), timeBeforeNextRequest);
          timeBeforeNextRequest += 1000;
        }
      };

      if (!state.orderInfo)
        if (orderId) {
          await getResultData();
        } else {
          window.close();
        }
    } catch (e) {
      errorException(e, commit, 'loadPageAfterPayment');
      commit(types.SET_LOADING, { loadPageAfterPayment: false });
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { loadPageAfterPayment: false });
    }
  },

  async checkPushkinPaymentAndSetOrderInfo(
    { state, commit, getters },
    { paymentId },
  ) {
    console.log('checkPaymentAndSetOrderInfo2');
    try {
      const userSessionId = getters.getUserSessionId;

      await pageChangeLog(
        { PageType: 'ToPaymentResult', Direction: 'Forward' },
        userSessionId,
      );

      let totalTime = 0;

      const getResultData = async () => {
        try {
          const resultData = await getResultPayment(
            { paymentId },
            userSessionId,
          );
          commit(types.SET_ORDER_INFO_AFTER_PAYMENT, resultData);

          if (!state.orderInfo.status !== 'Succeed')
            throw new Error('Не удалось оплатить заказ.');

          return { success: true };
        } catch (e) {
          if (totalTime > state.theatre.SessionDuration * 60 * 1000) {
            commit(
              types.ADD_ERROR,
              'Время оплаты заказа истекло. Повторите заказ.',
            );
            return { success: false, error: e.message };
          }

          setTimeout(async () => await getResultData(), 10000);
          totalTime += 10000;
        }
      };

      if (!state.orderInfo) {
        await getResultData();
      }
    } catch (e) {
      errorException(e, commit, 'checkPaymentAndSetOrderInfo2');
      return { success: false, error: e.message };
    }
  },

  async checkPaymentAndSetOrderInfo({ state, commit, getters }, { paymentId }) {
    try {
      const userSessionId = getters.getUserSessionId;

      await pageChangeLog(
        { PageType: 'ToPaymentResult', Direction: 'Forward' },
        userSessionId,
      );

      let totalTime = 0;

      const getResultData = async () => {
        try {
          const resultData = await getProcessingResult(
            { status: 'Paid', paymentId },
            userSessionId,
          );
          commit(types.SET_ORDER_INFO_AFTER_PAYMENT, resultData);
          return { success: true };
        } catch (e) {
          if (totalTime > state.theatre.SessionDuration * 60 * 1000) {
            commit(
              types.ADD_ERROR,
              'Время оплаты заказа истекло. Повторите заказ.',
            );
            return { success: false, error: e.message };
          }

          setTimeout(async () => await getResultData(), 10000);
          totalTime += 10000;
        }
      };

      if (!state.orderInfo) {
        await getResultData();
      }
    } catch (e) {
      errorException(e, commit, 'checkPaymentAndSetOrderInfo');
      return { success: false, error: e.message };
    }
  },

  async getTheatreInfo({ commit }, { theatreId }) {
    try {
      const getTheatreData = await getTheatre(theatreId);
      commit(types.SET_THEATRE, getTheatreData);
    } catch (e) {
      errorException(e, commit, 'getTheatreInfo');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { getTheatreInfo: false });
    }
  },

  async loadHall({ state, commit, dispatch }, payload) {
    const { theatreId, session, idToken, filmId } = payload;

    try {
      if (state.promoData) {
        commit(types.CLEAR_PROMO_CODE_DATA);
      }

      commit(types.SET_LOADING, { loadHall: true });

      commit(types.SET_ID_TOKEN, idToken);
      commit(types.SET_THEATRE_ID, theatreId);
      commit(types.SET_SESSION_ID, session);

      const filmBasic = await getFilmBasic({ filmId: filmId || '' });
      commit(types.SET_MOVIE, filmBasic);

      await dispatch('getNotificationsAction', { theatreId, filmId, session });

      if (!state.theatre.Name) {
        const getTheatreData = await getTheatre(theatreId);
        console.log(getTheatreData);
        commit(types.SET_THEATRE, getTheatreData);
      }

      if (
        (state.setting.enabledPayments || []).length === 0 ||
        (state.setting.paymentMethods || []).length === 0
      ) {
        const theatrePaymentInfo = await getTheatrePaymentInfo({
          theatreId,
          filmId,
        });
        commit(types.SET_THEATRE_PAYMENT_INFO, theatrePaymentInfo);
      }

      if (
        !state.bar.length &&
        (!filmBasic.Flag || state.theatre.TheaterAllowingParallelBar)
      ) {
        await dispatch('loadBar', {
          theatreId,
          saleFilter: 'SaleEnabled',
        });
        commit(types.CLEAR_ERRORS);
      }

      if (filmBasic.Flag && !state.theatre.TheaterAllowingParallelBar)
        state.bar = [];

      if (!state.theatre.PrivacyPolicyData || !state.theatre.PrivacyConsentData) {
        //const privacy = await privacyPolicy({ theatreId: payload.theatreId });
        //await commit(types.SET_PRIVACY_POLICY, privacy);
        const privacyDocData = {theatreId: theatreId};
        const getPrivactResponse = await getPrivacyDocuments(privacyDocData);
        commit(types.SET_THEATER_PRIVACY_DOCUMENTS, getPrivactResponse);
      }

      const hallStatusData = await getHallStatus({
        theatreId,
        sessionId: session,
        showObjects: false,
      });
      const sessionPricesData = await getSessionPrices({
        theatreId,
        sessionId: session,
      });

      hallStatusData.Prices = sessionPricesData;

      if (
        router.history.current.params.theatreId ===
          'clbkbxpys3q3u072942lrvxqh' ||
        router.history.current.params.theatreId ===
          'claw7cyiocqps0729kmuum8b3' ||
        router.history.current.params.theatreId === 'cl9shcwgund200729ocmj7hae'
      ) {
        // eslint-disable-next-line no-unused-vars
        let places = hallStatusData.Hall.Levels[0].Places;
        places = places.map((place) => {
          place.X += 69;
        });
      }

      await commit(types.SET_SESSION, hallStatusData);
    } catch (e) {
      commit(types.SESSION_WITHOUT_PLACES);
      errorException(e, commit, 'loadHall');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { loadHall: false });
    }
  },

  async loadApp({ commit }, payload) {
    const { theatreId, session, idToken, filmId } = payload;

    try {
      commit(types.SET_LOADING, { loadApp: true });

      commit(types.SET_ID_TOKEN, idToken);
      commit(types.SET_THEATRE_ID, theatreId);
      commit(types.SET_SESSION_ID, session);

      const getTheatreData = await getTheatre(theatreId);
      commit(types.SET_THEATRE, getTheatreData);

      const theatrePaymentInfo = await getTheatrePaymentInfo({
        theatreId,
        filmId,
      });
      commit(types.SET_THEATRE_PAYMENT_INFO, theatrePaymentInfo);
    } catch (e) {
      errorException(e, commit, 'loadApp');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { loadApp: false });
    }
  },

  async openBuyPage(
    { commit, state, dispatch },
    { theatreId, session, filmId },
  ) {
    // const userSessionGuid = this.state.user.sessionId;
    // const authToken = this.state.authToken;

    try {
      commit(types.SET_LOADING, { openBuyPage: true });

      if (state.authToken) {
        await dispatch('loadProfile', { theatreId });
        await dispatch('fetchCustomerAccounts', { theatreId });
      }

      if (!state.data.notifications) {
        await dispatch('getNotificationsAction', {
          theatreId,
          session,
          filmId,
        });
      }
    } catch (e) {
      errorException(e, commit, 'openBuyPage');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { openBuyPage: false });
    }
  },

  async usePromocode({ commit, state }, { Promocode, Email }) {
    const userSessionGuid = this.state.user.sessionId;
    const authToken = this.state.authToken;

    try {
      commit(types.SET_LOADING, { usePromocode: true });

      if (!Promocode || Promocode === '')
        throw Error('Необходимо ввести промокод');

      const promoCodeData = await useDiscountPromoCode(
        {
          OrderId: state.orderId,
          Promocode,
          Email,
        },
        userSessionGuid,
        authToken,
      );

      if (promoCodeData) {
        commit(types.SET_PROMO_CODE_DATA, {
          promoCodeData,
          promoName: 'С учетом промокода',
        });
        commit(types.CALCULATE_CART);
      }
    } catch (e) {
      errorException(e, commit, 'usePromocode');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { usePromocode: false });
    }
  },

  async updateFilmWthSchedule({ commit, getters }, { cityId, filmId, date }) {
    try {
      const userSessionId = getters.getUserSessionId;

      const filmWithSchedule = await getFilmWthSchedule(
        { cityId, filmId, date },
        userSessionId,
      );

      commit(types.GET_FILM_WITH_SCHEDULE, filmWithSchedule);
    } catch (e) {
      errorException(e, commit, 'updateFilmWthSchedule');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { updateFilmWthSchedule: false });
    }
  },

  async changeFormForSchedule({ state }, date) {
    state.data.scheduleForm.selectDate = date.dateNow;
  },

  async filmScheduleOpen({ commit, getters }, { cityId, filmId, date }) {
    commit(types.SET_LOADING, { filmScheduleOpen: true });

    try {
      const filmWithSchedule = await getFilmWthSchedule(
        { cityId, filmId, date },
        getters.getUserSessionId,
      );

      commit(types.GET_FILM_WITH_SCHEDULE, filmWithSchedule);
    } catch (e) {
      errorException(e, commit, 'filmScheduleOpen');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { filmScheduleOpen: false });
    }
  },

  async getCitiesWithTheatres({ commit }, payload) {
    try {
      const cities = await getCitiesWithTheatres(payload);
      commit(types.SET_CITIES, cities);
      return cities;
    } catch (e) {
      errorException(e, commit, 'getCitiesWithTheatres');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { getCitiesWithTheatres: false });
    }
  },

  async getTheatresByCity({ commit }, payload) {
    try {
      const citySelected = await getCities();
      const theatres = await getTheatresByCity(payload);
      commit(types.SET_THEATRES, {
        city: citySelected.filter((city) => city.id === payload.cityId),
        theatres,
      });
    } catch (e) {
      errorException(e, commit, 'getTheatresByCity');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { getTheatresByCity: false });
    }
  },

  async reserveTicket({ commit, state }, payload) {
    const { theatreId } = payload;

    try {
      commit(types.SET_LOADING, { reserveTicket: true });

      const userSessionGuid = this.state.user.sessionId;
      const authToken = this.state.authToken;

      const requestData = {
        SessionId: this.state.session.Id,
        Seats: this.state.cart.tickets.map(({ id, number, row, typeId }) => ({
          Id: id,
          TypeId: state.places.find((place) => place.Id === id).TypeId,
          Row: row,
          Number: number,
          VariantId: typeId,
        })),
        TheatreId: theatreId,
      };

      if (state.orderId) requestData.OrderId = state.orderId;

      const response = await reserveTicket(
        requestData,
        userSessionGuid,
        authToken,
      );

      if (response) {
        commit(types.SET_ORDER_ID, response.OrderId);
      } else {
        commit(types.ADD_ERROR, response.data.data);
      }
    } catch (e) {
      errorException(e, commit, 'reserveTicket');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { reserveTicket: false });
    }
  },

  async barReserve({ commit, state }, payload) {
    try {
      const { selectTime, selectDate } = state.data.barForm;

      const { theatreId } = payload;

      const userSessionGuid = this.state.user.sessionId;
      const authToken = this.state.authToken;
      const requestData = {
        Items: this.state.cart.bar.map(({ Id, count, Name }) => ({
          ProductId: Id,
          Count: count,
          Name,
        })),
        TheatreId: theatreId,
      };

      if (selectDate && selectTime) {
        const [hours, minutes] = selectTime.split(':');

        const dateWithHourse = new Date(selectDate).setHours(hours);
        const dateWithMinutes = new Date(dateWithHourse).setMinutes(minutes);
        const deliveryTime = new Date(dateWithMinutes);

        requestData.DeliveryTime = new Date(
          deliveryTime.getTime() - deliveryTime.getTimezoneOffset() * 60000,
        ).toJSON();
      }

      if (state.orderId) requestData.OrderId = state.orderId;

      const response = await reserveBar(
        requestData,
        userSessionGuid,
        authToken,
      );

      if (response) {
        commit(types.SET_ORDER_ID, response.OrderId);
        commit(types.CLEAR_BAR_ZERO_ITEMS);
      } else {
        commit(types.ADD_ERROR, response.data);
      }
    } catch (e) {
      errorException(e, commit, 'barReserve');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { barReserve: false });
    }
  },

  async cancelBarReserve({ commit, state }, payload) {
    try {
      const { selectTime, selectDate } = state.data.barForm;

      const { theatreId } = payload;

      const userSessionGuid = this.state.user.sessionId;
      const authToken = this.state.authToken;
      const requestData = {
        Items: this.state.cart.bar.map(({ Id, Name }) => ({
          ProductId: Id,
          Count: 0,
          Name,
        })),
        TheatreId: theatreId,
      };

      if (selectDate && selectTime) {
        const [hours, minutes] = selectTime.split(':');

        const dateWithHourse = new Date(selectDate).setHours(hours);
        const dateWithMinutes = new Date(dateWithHourse).setMinutes(minutes);
        const deliveryTime = new Date(dateWithMinutes);

        requestData.DeliveryTime = new Date(
          deliveryTime.getTime() - deliveryTime.getTimezoneOffset() * 60000,
        ).toJSON();
      }

      if (state.orderId) requestData.OrderId = state.orderId;

      const response = await reserveBar(
        requestData,
        userSessionGuid,
        authToken,
      );

      if (response) {
        commit(types.SET_ORDER_ID, response.OrderId);
      } else {
        commit(types.ADD_ERROR, response.data);
      }
    } catch (e) {
      errorException(e, commit, 'barReserve');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { barReserve: false });
    }
  },

  // Send request to createOrder to backend
  async createOrder({ commit, getters, state }, payload) {
    try {
      const { email, name, phone, isAgreementsAccepted } = state.user;
      var isAgreementsAcceptedBool = !isAgreementsAccepted  ? false : true;

      const bankType = payload.isSbpSelected
        ? 'Sbp'
        : (state.setting.paymentMethods[0] || {}).BankType;

      commit(types.SET_LOADING, { createOrder: true });

      const userSessionId = getters.getUserSessionId;

      const getPaymentMethod = () => {
        if (state.user.paymentType === 'Base') {
          return 'Base';
        } else if (state.user.paymentType === 'PushkinFilm') {
          return state.session.IsEvent ? 'PushkinEvent' : 'PushkinFilm';
        }
      };

      const submitPayload = {
        BonusesAmount: state.cart.usedBonuses,
        Email: email,
        Name: name ? name : 'Неизвестный пользователь',
        Phone: phone
          .replace(/\(|\)|-/g, '')
          .split(' ')
          .join(''),
        BankType: bankType,
        PaymentType: getPaymentMethod(),
        OrderId: state.orderId,
        IsAgreementsAccepted:  isAgreementsAcceptedBool
      };

      if (state.cart.donations) {
        submitPayload.Donation = {
          ProductId: state.theatre.Donation.Id,
          Name: state.theatre.Donation.Title,
          Amount: state.cart.donations,
        };
      }

      if (state.giftCards.allowed && state.giftCards.enabled && state.user.isAuthorized &&
        state.user.paymentType !== 'PushkinFilm' && (state.giftCards.busy || !state.giftCards.ready)) {
        throw new Error('Дождитесь обновления подарочных карт или отключите их использование');
      }
      const giftPayments = getters['giftCards/payments'];
      if (giftPayments.length) {
        if (state.giftCards.busy || !state.giftCards.ready ||
          new Set(giftPayments.map(p => p.CardId)).size !== giftPayments.length ||
          giftPayments.some(p => !Number.isInteger(p.AmountRubles) || p.AmountRubles <= 0 ||
            !state.giftCards.cards.some(c => c.CardId === p.CardId && c.CurrentBalance >= p.AmountRubles)) ||
          getters['giftCards/amount'] > Number(state.cart.sum)) {
          throw new Error('Обновите доступные подарочные карты и суммы списания');
        }
        submitPayload.GiftCardPayments = giftPayments;
      }
      const response = await submitOrder(submitPayload, userSessionId);

      if (response.IsFreeOrder || response.IsPrepaidFull) {
        commit(types.SET_ORDER_INFO_AFTER_PAYMENT, response.Order);
        router.push(`/success${urlQueryParts({ userSession: userSessionId })}`);
        return { completed: true };
      }

      return {
        formUrl: response.FormUrl,
        paymentId: response.PaymentId,
      };
    } catch (e) {
      if (getters['giftCards/payments'].length && (e.code || e.status)) {
        e.message = giftCardError(e);
      }
      errorException(e, commit, 'createOrder');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { createOrder: false });
    }
  },

  async fetchUserBalance({ commit, state }, payload) {
    try {
      //debugger;
      if (state.setting.isBonusesAvailable) {
        let response = await axios
          .post(
            setting.apiHost + `/v1/user/get-user?apiKey=${payload.apiKey}`,
            {
              cardNumbers: payload.card,
              includeCards: 'true',
              includeAccounts: 'true',
            },
          )
          .catch((error) => {
            throw error;
          });

        if (response.data.success === true) {
          // if card exist
          if (response.data.data.id) {
            this.commit(types.SET_USER_BALANCE, response.data.data);
            this.commit(types.CALCULATE_USER_MAX_BONUSES);
          }
        } else {
          commit(types.ADD_ERROR, response.data.data);
        }
        commit(types.CLEAR_ERRORS, 4000);
      }
    } catch (e) {
      errorException(e, commit, 'fetchUserBalance');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { fetchUserBalance: false });
    }
  },

  async fetchCustomerAccounts({ commit, state }, { theatreId }) {
    try {
      const userData = await getProfile({ theatreId });
      commit(types.SET_USER_DATA, userData);

      const { idToken, user } = state;
      const accounts = user.crmSystem.Accounts;

      if (idToken && accounts) {
        commit(types.SET_CUSTOMER_ACCOUNTS, accounts);
        commit(types.CALCULATE_CART);
        commit(types.SET_USER_BALANCE, accounts);
      } else {
        console.log('invalid arguments fetchCustomerAccounts', idToken);
      }

      return accounts;
    } catch (e) {
      errorException(e, commit, 'fetchCustomerAccounts');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { fetchCustomerAccounts: false });
    }
  },

  async getNotificationsAction({ commit }, payload) {
    try {
      const { theatreId, filmId, session } = payload;
      const cityId = await getTheatre(payload.theatreId);
      const notifications = await getNotifications({
        cityId: cityId.CityId,
        theatreId,
        filmId,
        seanceId: session,
      });
      await commit(types.SET_NOTIFICATIONS, notifications);
    } catch (e) {
      errorException(e, commit, 'getNotificationsAction');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { getNotificationsAction: false });
    }
  },
};

export default actions;
